import type { FC } from "react";

import {
  EMBEDDING_KEY_MISSING_MESSAGE,
  EMBEDDING_KEY_MISSING_TITLE,
  EMBEDDING_KEY_PRESENT_MESSAGE,
  type EmbeddingKeyCandidate,
  hasEmbeddingKey,
} from "../../constants/embeddingReadiness";
import { Alert } from "./Alert";

/**
 * Tells an organization whether Skill Mesh semantic search can run: it needs
 * the embedding provider's key, and degrades to keyword-only without it.
 */
export const EmbeddingReadinessNotice: FC<{
  className?: string;
  keys: readonly EmbeddingKeyCandidate[];
}> = ({ className, keys }) =>
  hasEmbeddingKey(keys) ? (
    <Alert variant="info" size="sm" className={className}>
      {EMBEDDING_KEY_PRESENT_MESSAGE}
    </Alert>
  ) : (
    <Alert
      variant="warning"
      title={EMBEDDING_KEY_MISSING_TITLE}
      className={className}
    >
      {EMBEDDING_KEY_MISSING_MESSAGE}
    </Alert>
  );
